export type PartnerQueueViewState = "loading" | "error" | "ready" | "stale";

/**
 * A failed background refetch must not wipe a previously loaded queue.
 * Only the first load (no data) is a hard empty error.
 */
export function partnerQueueViewState(input: {
  hasData: boolean;
  isPending: boolean;
  isError: boolean;
}): PartnerQueueViewState {
  if (input.hasData) return input.isError ? "stale" : "ready";
  if (input.isPending) return "loading";
  if (input.isError) return "error";
  return "ready";
}
